import { CalloutBox } from 'components/Docs/CalloutBox';
import MergingIssues from "../../../../contents/docs/error-tracking/_snippets/merging-issues.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  MergingIssues,
  React
};